import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateWIRUsers } from '../../../../redux/WellGuardian';
import { useCountryState } from '../../../../redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';

const READ_ONLY_WIR_USER = 'READ_ONLY_WIR_USER';

export const useFetchWgUsersList = () => {
  const [usersLoading, setUsersLoading] = useState<boolean>(false);
  const countryState = useCountryState();

  const dispatch = useDispatch();

  const fetchUsersList = useCallback(async () => {
    setUsersLoading(true);
    const allUsers = await wellGuardianApiClient.wirUsersList(READ_ONLY_WIR_USER, countryState);
    if (allUsers) {
      const finalUsers = allUsers?.filter(x => x.country === countryState);
      dispatch(updateWIRUsers(finalUsers));
    }
    setUsersLoading(false);
  }, [dispatch, countryState]);

  return {
    usersLoading,
    fetchUsersList,
    setUsersLoading,
  };
};
